import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
import {API_URL} from '../utils/EnvVars';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
///import { useSelector } from 'react-redux';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
  var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  const [organisationName, setOrganisationName] = React.useState("");

  const [open, setOpen] = React.useState(false);
  const [feedbackInput, setFeedbackInput] = React.useState("");
	const [showAlert, setShowAlert] = React.useState(false);
  const [submitAction, setSubmitAction] = React.useState(false);
	const [submitForm, setSubmitForm] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	
	var vertical='top',horizontal='center';
  
  function hideAlert(){
		setShowAlert(false);
	}

  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setSubmitForm(false);
    setOpen(false);
  };


  React.useEffect(() => {
		setSubmitAction(false);
    setSubmitForm(false);
	}, [open,props.currentQuestionObj.questionDisplayId]);

  React.useEffect(() => {
    if(mySelectedCourses!==null && selectedCourse>=0){
		  setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
    }
	}, [mySelectedCourses, selectedCourse]);

  function submit(){
		
		if(!feedbackInput || (feedbackInput && feedbackInput.length<1)){
			setShowAlert(true);
			setAlertMessage("Enter your feedback details.");
			document.getElementById("feedbackinputid").focus();			
			return false;

		}else{
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};		  
			const data = new FormData();
      if(props.currentQuestionObj && props.currentQuestionObj.questionDisplayId){
        data.append('questionId', props.currentQuestionObj.questionDisplayId);
      }
      data.append('feedback', feedbackInput);
      if(organisationName){
        data.append('courseName', organisationName);
      }
      setSubmitAction(true);
			axios.post(API_URL+'/teacher-support-question', data, axiosHeader)
			.then((response) => {
				setSubmitAction(false);
				if(response && response.data && response.data.responseTxt=="success"){
					setSubmitForm(true);

				}else{
					setShowAlert(true);
					setAlertMessage("Error somewhere, Try after sometime.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
		}  
	}
	

  return (
    <>
			<Button title="Teacher support for this question" variant="contained" onClick={handleClickOpen} style={{backgroundColor:'#ae40f7', color:'#FFF'}} >Teacher Support</Button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle onClose={handleClose}>
        Teacher Support For Question Id: {props.currentQuestionObj?.questionDisplayId}  
        </DialogTitle>

        <DialogContent dividers>            
              {submitForm?
              <span style={{color:'#dea338',fontSize:16,fontWeight:'bold',lineHeight:2}}>Your feedback has been submitted successfully.</span>
              :<div>
                <TextField
                    onChange={event => setFeedbackInput(event.target.value)}
                    id="feedbackinputid"
                    label="Type your message here"
                    multiline                  
                    rows={4}
                    fullWidth
                />   

                    {submitAction?
                      <LoadingButton 											
                      loading
                      loadingPosition="start"		
                      startIcon={<div style={{marginRight:25}}></div>}									
                      variant="outlined"
                      color="secondary"
                      style={{backgroundColor:'#f09766',color:'#FFFFFF',marginTop:20}}
                    >
                      Wait...
                    </LoadingButton>
                    :
										<Button onClick={()=>{submit()}} style={{backgroundColor:'#008000',color:'#FFFFFF',marginTop:20}} size="small" variant="contained">SUBMIT</Button>
									}
            
                <Button onClick={() => { handleClose() }} style={{marginLeft:20, marginTop:20}} size="small" variant="outlined" >Close</Button>


                </div>
              }               
             
        </DialogContent>

        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

      </Dialog>

    </>
  );
}
